"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypes = exports.StreamEvent = void 0;
const delivery_1 = require("../../../delivery");
const Insert = 'Insert';
exports.StreamEvent = Object.assign(Object.assign({}, delivery_1.OMMStreamEvent), { Insert });
var StreamTypes;
(function (StreamTypes) {
    StreamTypes["facade"] = "facade";
    StreamTypes["pricing"] = "pricing";
})(StreamTypes || (StreamTypes = {}));
var EventTypes;
(function (EventTypes) {
    EventTypes[EventTypes["Trade"] = 1] = "Trade";
    EventTypes[EventTypes["Quote"] = 2] = "Quote";
    EventTypes[EventTypes["Correction"] = 4] = "Correction";
})(EventTypes || (exports.EventTypes = EventTypes = {}));
